
export default class GrmObservable {
    #data = {}
    create(name, callback) {
        delete this.#data[name];

        let data = this.#data[name] = {
            complete: false,
            listeners: {
                subscribe: []
            },
            obs: {
                next: (result)=>{
                    if(data.complete){
                        console.warn('completed already');
                        return;
                    }
                    data.listeners.subscribe.forEach(sub => {
                        sub.next(result);
                    });
                },
                error: (e)=>{
                    if(data.complete){
                        console.warn('completed already');
                        return;
                    }
                    data.listeners.subscribe.forEach(sub => {
                        sub.error(e);
                    });
                },
                complete: (result)=>{
                    if(data.complete){
                        console.warn('completed already');
                        return;
                    }
                    if(result !== undefined){
                        data.obs.next(result);
                    }
                    data.complete = true;
                    data.listeners.subscribe.forEach(sub => {
                        sub.complete();
                    });
                    delete data.listeners.subscribe;
                    delete this.#data[name];
                },
            },
            sub: {
                subscribe: (next, error, complete)=>{
                    if(data.complete){
                        return this;
                    }
                    data.listeners.subscribe.push({next, error, complete});
                    return this;
                }
            }
        };
        Object.freeze(data.obs);
        Object.freeze(data.sub);

        setTimeout(() => {
            callback(data.obs);
        });
        return data.sub;
    }
    getOrCreate(name, callback) {
        let data = this.#data[name];
        if(data){
            return data.sub;
        }
        return this.create(name, callback);
    }
}
